import { render } from "./ProcedureBody.vue?vue&type=template&id=53409006&scoped=true"
import script from "./ProcedureBody.vue?vue&type=script&lang=js"
export * from "./ProcedureBody.vue?vue&type=script&lang=js"

import "./ProcedureBody.vue?vue&type=style&index=0&id=53409006&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53409006"]])

export default __exports__